import React, { Component, PureComponent, Fragment } from 'react'
import { Group } from '~/form'
import { Button, Table, Message } from 'semantic-ui-react'

export default class PeopleAddFromSheet extends Component {
  state = {
    textarea: '',
  }

  processValue = () => {
    let { textarea } = this.state
    return textarea
      .split('\n')
      .filter(s => s.length > 0)
      .map(r => r.split('\t').map(s => s.trim()))
  }

  saveProcessed = () => {
    let processed = this.processValue()
    this.props.onChange(processed, true)
  }

  render() {
    let { values, onChange, rowErrors } = this.props
    let { textarea } = this.state

    return (
      <div className="ui form">
        <Group>
          <div className="field form-field">
            <label htmlFor="add-people-raw">Kopioi taulukko-ohjelmasta</label>
            <div className="field form-input form-input--textarea">
              <textarea
                value={textarea}
                onChange={e => this.setState({ textarea: e.target.value })}
                onBlur={e => this.saveProcessed()}
                id="add-people-raw"
              />
            </div>
            <div className="form-field-description">Taulukon kolumnit: Nimi, Sähköposti, Puhelin</div>
          </div>
        </Group>
        {values.length > 0 ? (
          <Group title={`Esikatsele tuontia (${values.length})`}>
            <Table compact>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell content="Nimi" />
                  <Table.HeaderCell content="Sähköposti" />
                  <Table.HeaderCell content="Puhelinnumero" />
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {values.map((row, key) => {
                  let errors = rowErrors[key] || false
                  return (
                    <Fragment key={key}>
                      <Table.Row>
                        <Table.Cell>{row[0] || ''}</Table.Cell>
                        <Table.Cell>{row[1] || ''}</Table.Cell>
                        <Table.Cell>{row[2] || ''}</Table.Cell>
                      </Table.Row>
                      {errors ? (
                        <Table.Row error>
                          <Table.Cell>{errors[0] || ''}</Table.Cell>
                          <Table.Cell>{errors[1] || ''}</Table.Cell>
                          <Table.Cell>{errors[2] || ''}</Table.Cell>
                        </Table.Row>
                      ) : null}
                    </Fragment>
                  )
                })}
              </Table.Body>
            </Table>
          </Group>
        ) : null}
      </div>
    )
  }
}
